import React from 'react';
import { Icon } from './Icon';

export interface FieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  icon?: string;
  onClear?: () => void;
  /** Accessible name for the input — required when no visible <label> wraps it. */
  ariaLabel?: string;
}

export const Field = ({
  value,
  onChange,
  placeholder,
  icon,
  onClear,
  ariaLabel,
}: FieldProps) => (
  <div className="tw-flex tw-items-center tw-gap-[8px] tw-h-[40px] tw-bg-white tw-border tw-border-ds-hairline tw-rounded-full tw-px-[16px] tw-box-border focus-within:tw-border-ds-primary focus-within:tw-border-2 focus-within:tw-px-[15px]">
    {icon && <Icon name={icon} size={18} color="var(--ink-mute)" />}
    <input
      value={value}
      aria-label={ariaLabel}
      onChange={onChange}
      placeholder={placeholder}
      type="text"
      // !tw-bg-transparent (important) is required: legacy global `input { background-color: #F3F3F3 !important }`
      // rules outrank a plain tw-bg-transparent. The important class (0,1,0) beats the bare element rule (0,0,1).
      className="tw-border-0 tw-outline-none !tw-bg-transparent tw-w-full tw-font-poppins tw-text-[14px] tw-text-ds-storm"
    />
    {onClear && value && (
      <button
        type="button"
        onClick={onClear}
        className="tw-border-0 tw-bg-transparent tw-cursor-pointer tw-flex tw-p-0"
      >
        <Icon name="x" size={16} color="var(--ink-mute)" />
      </button>
    )}
  </div>
);
